import { Component } from '@angular/core';

@Component({
  selector: 'app-communities-preview-search',
  templateUrl: './communities-recipes-preview.component.html',
  standalone: false,
})
export class CommunitiesRecipesPreviewComponent {}
